import { Form } from "react-bootstrap";
import { withPopover } from "shared/lib/hocs/withPopover";
import FormGroup from "../FormGroup/FormGroup";

const Input = function Input({
  name = "",
  register = (name) => ({}),
  setValue = (name, any) => {},
  control = null,
  error = null,
  label = null,
  addon = null,
  popoverRef = (el) => ({}),
  popoverHandlers = null,
  displayAs = Form.Group,
  className = "",
  text = null,
  md = 6,
  ...props
}) {
  const { ref: formRef, ...rest } = register(name);
  return (
    <FormGroup
      controlId={name}
      label={label}
      addon={addon}
      error={error}
      displayAs={displayAs}
      className={className}
      text={text}
      md={md}
    >
      <Form.Control
        ref={(el) => {
          popoverRef(el);
          formRef && formRef(el);
        }}
        {...popoverHandlers}
        isInvalid={!!error}
        {...rest}
        {...props}
      />
    </FormGroup>
  );
};

Input.WithPopover = withPopover(Input);
// ? Wrapping Input in memo will cause problems with react hook form (ex. reset() fn)
export default Input;
